import type { SVGProps } from 'react'

export const FrenchFlag = ({ className, ...svgProps }: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 16" className={className} {...svgProps}>
      <rect width="8" height="16" fill="#0055A4" />
      <rect x="8" width="8" height="16" fill="#ffffff" />
      <rect x="16" width="8" height="16" fill="#EF4135" />
    </svg>
  )
}
